/** Util fucntions for:
 * getting screen titles depends on location paths
 * getting style props depends on location paths.
 * This is used in Header Main component.
 * 
*/
export const getHeaderTitle = (pathname, t) => {

  
  if (pathname.startsWith('/explore/')) {
    return t('footer.articles');
  }

  const titles = {
    '/': t('footer.home'),
    '/events': t('footer.events'),
    '/add': t('footer.addEvent'),
    '/explore': t('footer.explore'),
    
    '/profile': t('footer.pets'),
    '/notifications': t('footer.notifications'), 
  };

  return titles[pathname] || '';

};

export const isWhiteTitlePath = (pathname) =>
  [ '/add', '/', '/profile'].includes(pathname);

export const isGreenBackgroundPath = (pathname) =>
  ['/add', '/profile', '/', '/explore/'].includes(pathname);

export const isGrayBackgroundPath = (pathname) =>
  ['/events', '/explore'].includes(pathname);



